registerComponent("blocks/asacom-alert", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * A faixa de anúncio do topo da home, que só aparece com `#asacom` na URL, 1,3s
 * depois do boot — os dois são de 2020 e ficam.
 *
 * O que era TweenLite virou CSS. Em 2020 três tweens escreviam inline, a cada
 * abertura e fechamento: `margin-top` da própria faixa (de `-altura` a 0),
 * `margin-top` do header e `padding-top` do <main> (de 0 a `altura`). Agora a
 * faixa mede a própria altura, grava em `--asacom-altura` no <body>, e duas
 * classes fazem o resto: `.is-fora` nela (`_asacom-alert.less`) e
 * `asacom-visivel`/`asacom-saindo` no <body> (`_legacy.less`, onde moram as
 * regras do header e do <main>, que estão fora deste componente).
 *
 * O `display: flex` continua vindo do JS porque o call site
 * (`pages/index.blade.php`) tem `style="display:none"` inline, e o Blade não
 * muda: só um estilo inline ganha de outro.
 *
 * O `refererUrl` de 2020 (`document.referrer` lido e nunca usado) saiu.
 */

const botaoFechar = component.querySelector('button');
const corpo = document.body;

let temporizador = null;

function medir() {
    corpo.style.setProperty('--asacom-altura', `${component.offsetHeight}px`);
}

function mostrar() {
    // Do `display: none` ao "fora da tela" não há transição: o navegador não
    // anima um elemento que acaba de passar a ser renderizado. É o que dá o
    // estado "antes" sem piscar — desde que a medida venha ANTES da classe,
    // senão `.is-fora` pinta um quadro com o fallback da variável.
    component.style.display = 'flex';
    medir();
    component.classList.add('is-fora');

    const entrar = () => {
        component.classList.remove('is-fora');
        corpo.classList.add('asacom-visivel');
    };

    // Dois quadros para que o "antes" seja pintado; o setTimeout é a rede de
    // segurança da aba em segundo plano (o mesmo padrão de Asa.revelar).
    requestAnimationFrame(() => requestAnimationFrame(entrar));
    setTimeout(entrar, Asa.ESPERA_MAXIMA);
}

function terminarDeFechar() {
    clearTimeout(temporizador);
    component.removeEventListener('transitionend', aoTerminarTransicao);
    corpo.classList.remove('asacom-saindo');
    corpo.style.removeProperty('--asacom-altura');
    component.remove();
}

/** Só o `margin-top` da própria faixa conta — o resto sobe dos filhos. */
function aoTerminarTransicao(evento) {
    if (evento.target === component && evento.propertyName === 'margin-top') {
        terminarDeFechar();
    }
}

function fechar() {
    medir();
    component.classList.add('is-fora');
    corpo.classList.remove('asacom-visivel');
    corpo.classList.add('asacom-saindo');

    // Sem transição (quem pediu menos movimento) não há `transitionend`.
    if (!Asa.movimentoPermitido()) {
        terminarDeFechar();

        return;
    }

    component.addEventListener('transitionend', aoTerminarTransicao);
    temporizador = setTimeout(terminarDeFechar, Asa.ESPERA_MAXIMA);
}

if (botaoFechar) {
    botaoFechar.addEventListener('click', fechar);
}

if (window.location.hash === '#asacom') {
    setTimeout(mostrar, 1300);
}

});
